import { Component, inject } from '@angular/core';
import { PwaInstallService } from './pwa-install.service';

@Component({
  selector: 'app-install-app',
  standalone: true,
  template: `
    @if (!install.installed()) {
      <button type="button" (click)="install.install()" class="fixed right-3 bottom-[82px] lg:bottom-5 z-[80] h-10 px-3 rounded-xl bg-[#102C41] text-white shadow-lg border border-white/10 flex items-center gap-2 text-xs font-bold">
        <i class="ti ti-device-mobile-down text-[17px]"></i><span>Install App</span>
      </button>
    }
    @if (install.instructionsOpen()) {
      <div class="fixed inset-0 z-[200] bg-slate-950/45 backdrop-blur-sm p-4 flex items-center justify-center" (click)="install.closeInstructions()">
        <section class="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-2xl overflow-hidden" (click)="$event.stopPropagation()">
          <div class="p-5 border-b border-slate-100 flex items-start justify-between gap-3">
            <div>
              <p class="text-[10px] font-bold uppercase tracking-widest text-[#1A6FA6]">NZ Plumbing</p>
              <h2 class="text-lg font-semibold text-slate-950 mt-1">Install Field App</h2>
            </div>
            <button type="button" (click)="install.closeInstructions()" class="w-8 h-8 rounded-lg bg-slate-100 text-slate-500">
              <i class="ti ti-x"></i>
            </button>
          </div>
          <div class="p-5 text-sm text-slate-600 leading-relaxed">
            @if (install.isIos) {
              <p>In Safari, tap <strong>Share</strong> <i class="ti ti-share-2"></i>, then choose <strong>Add to Home Screen</strong> and confirm.</p>
            } @else if (install.isAndroid) {
              <p>Tap <strong>Install App</strong> again after the page finishes loading. If Chrome does not show the installer, open the browser menu, choose <strong>Install app</strong> or <strong>Add to Home screen</strong>, then confirm.</p>
            } @else {
              <p>Open your browser menu and choose <strong>Install NZ Plumbing Field</strong>. Chrome or Edge may also show an install icon in the address bar.</p>
            }
            <div class="mt-4 rounded-xl bg-sky-50 border border-sky-100 p-3 text-xs text-sky-800">Once installed, open it like a normal app from your phone, tablet, or computer.</div>
          </div>
        </section>
      </div>
    }
  `
})
export class InstallAppComponent {
  install = inject(PwaInstallService);
}
